import React, { useState, useEffect } from "react";
import { Menu } from "semantic-ui-react";

// UX
import CardPackagePurchaseHistory from "./CardPackagePurchaseHistory";
import CardAppointmentUsageHistory from "./CardAppointmentUsageHistory";
import { useIntl } from "react-intl";

// Interface
import {
  MasterDataType,
  MasterOptionsType,
  RunSequence,
  State,
  StatusesFilterType,
} from "./sequence/PackagePurchase";
import { PackageDetailType } from "./sequence/SettingPackage";

// Types
type CardPurchaseHistoryProps = {
  setProp: (key: string, value: any, callback?: Function) => any;
  onEvent: (e: any) => any;
  // seq
  runSequence: RunSequence;
  PackagePurchaseSequence?: State["PackagePurchaseSequence"];
  // data
  masterData?: MasterDataType;
  // Filter
  statusesFilter?: StatusesFilterType;
  // CommonInterface
  searchedItemListWithKey?: Record<string, any>;
  buttonLoadCheck?: Record<string, any>;
  errorMessage?: Record<string, any>;
  onClickDescription?: (data: PackageDetailType) => void;
  // options
  masterOptions?: MasterOptionsType;
  // config
  selectable?: boolean; // สามารถเลือก checkbox รายการที่สามารถนัดหมายได้
  selectedDivision?: Record<string, any> | null; // default performed_division,
  disabledOrderIds?: number[];
  isPackageOrder?: boolean;
  inCartFilter?: boolean;
  hideTitle?: boolean;
  hidePackageTypeFilter?: boolean;
  hideProgramNameFilter?: boolean;
  hideDivisionFilter?: boolean;
  showPackageNameFilter?: boolean;
  filterByDivision?: boolean;
  packageBinderTitle?: string;
  // labels (optional overrides)
  confirmHeaderText?: string;
  selectPromptText?: string;
  confirmButtonText?: string;
  // callback
  onSelectPackage?: (data: Record<string, any>) => any;
  onClickAppointment?: () => void;
};

type ValueOf<T> = T[keyof T];

type TabPanKey = ValueOf<typeof TAB_PANS>;

// Const
const TAB_PANS = {
  PACKAGE_LIST: "Package List",
  APPOINTMENT: "Appointment & Usage History",
} as const;

const CARD_PURCHASE_HISTORY = "CardPurchaseHistory";

const CardPurchaseHistory = (props: CardPurchaseHistoryProps) => {
  const intl = useIntl();
  const [activeItem, setActiveItem] = useState<TabPanKey>(TAB_PANS.PACKAGE_LIST);

  // Use Effect
  useEffect(() => {
    // use action PurchaseHistory
    const getPurchaseHistory = async () => {
      // เมื่อมี division ให้ default ตาม division และ get ตาม division
      props.runSequence({
        sequence: "PackagePurchase",
        restart: true,
        nextIndex: "PurchaseHistory",
        card: CARD_PURCHASE_HISTORY,
        divisionId: props.selectedDivision?.id,
        statusesFilter: props.statusesFilter,
        inCartFilter: props.inCartFilter,
      });
    };

    getPurchaseHistory();
  }, []);

  // Handler
  const handleChangeTab = (_e: any, data: any) => {
    setActiveItem(data.name);
  };

  const handleOpenHistory = () => {
    setActiveItem(TAB_PANS.APPOINTMENT);
  };

  return (
    <div style={{ padding: "10px", paddingBottom: "1rem" }}>
      <Menu tabular>
        {Object.values(TAB_PANS).map((menu, index) => (
          <Menu.Item
            key={"menu-" + menu}
            active={activeItem === menu}
            name={menu}
            // disabled={props.selectable && menu === TAB_PANS.APPOINTMENT}
            style={
              activeItem === menu
                ? {
                    color: "#0370b7",
                  }
                : {}
            }
            onClick={handleChangeTab}
          >
            {menu}
          </Menu.Item>
        ))}
      </Menu>
      {activeItem === TAB_PANS.PACKAGE_LIST ? (
        <CardPackagePurchaseHistory
          setProp={props.setProp}
          onEvent={props.onEvent}
          // seq
          runSequence={props.runSequence}
          PackagePurchaseSequence={props.PackagePurchaseSequence}
          // data
          masterData={props.masterData}
          // Filter
          statusesFilter={props.statusesFilter}
          hidePackageTypeFilter={props.hidePackageTypeFilter}
          hideProgramNameFilter={props.hideProgramNameFilter}
          showPackageNameFilter={props.showPackageNameFilter}
          hideDivisionFilter={props.hideDivisionFilter}
          filterByDivision={props.filterByDivision}
          hideTitle={props.hideTitle}
          packageBinderTitle={props.packageBinderTitle}
          // labels
          confirmHeaderText={props.confirmHeaderText}
          selectPromptText={props.selectPromptText}
          confirmButtonText={props.confirmButtonText}
          // CommonInterface
          searchedItemListWithKey={props.searchedItemListWithKey}
          buttonLoadCheck={props.buttonLoadCheck}
          errorMessage={props.errorMessage}
          onClickDescription={props.onClickDescription}
          // options
          masterOptions={props.masterOptions}
          // config
          selectable={props.selectable}
          selectedDivision={props.selectedDivision}
          disabledOrderIds={props.disabledOrderIds}
          isPackageOrder={props.isPackageOrder}
          inCartFilter={props.inCartFilter}
          // callback
          onOpenHistory={handleOpenHistory}
          onSelectPackage={props.onSelectPackage}
          onClickAppointment={props.onClickAppointment}
          languageUX={props.languageUX}
        />
      ) : (
        activeItem === TAB_PANS.APPOINTMENT && (
          <CardAppointmentUsageHistory
            setProp={props.setProp}
            onEvent={props.onEvent}
            // seq
            runSequence={props.runSequence}
            PackagePurchaseSequence={props.PackagePurchaseSequence}
            hideTitle={props.hideTitle}
            // options
            masterOptions={props.masterOptions}
            // CommonInterface
            searchedItemListWithKey={props.searchedItemListWithKey}
            buttonLoadCheck={props.buttonLoadCheck}
            languageUX={props.languageUX}
          />
        )
      )}
    </div>
  );
};

export default React.memo(CardPurchaseHistory);
